import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

/*
  Generated class for the MathProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class MathProvider {

  constructor(public http: Http) {
    // console.log('Hello MathProvider Provider');
  }


  /**
   * Erzeugt eine zufällige Zahl zwischen 0 und 9 und liefert zwei Zahlen die für die Anzahl der Finger an der linken und rechten Hand stehen
   * 
   * @returns {[number, number]} Anzahl der 'Finger' an der linken und rechten Hand
   * @memberof MathProvider
   */
  public getfingers(): [number, number] {
    let num = Math.floor(Math.random() * 10);


    let left: number;
    let right: number;

    if (num > 5) {
      left = 5;
      right = num % 5;
    }
    else {
      left = num;
      right = 0;
    }

    let result: [number, number];
    result = [left, right];

    return result;
  }


  /**
   * Liefert eine zufällige ganze Zahl im angegebenen Bereich
   * 
   * @param {number} min Minimum
   * @param {number} max Maximum
   * @returns {number} zufällige Zahl
   * @memberof MathProvider
   */
  public getrandomnumber(min: number, max: number): number {
    let result = Math.floor(Math.random() * (1 + max - min)) + min;

    return result;
  }


  /**
   * Liefert eine bestimmte Anzahl von Zahlen in eibnem Array im angegeben Bereich mit zufälligem Startwert und angegebener Schrittweite
   * 
   * @param {number} min Minimum
   * @param {number} max Maximum
   * @param {number} step Schrittweite
   * @param {number} count Anzahl der Zahlen im Array
   * @returns {number[]} Array von Zahlen
   * @memberof MathProvider
   */
  public getnumberrange(min: number, max: number, step: number, count: number): number[] {

    //* Sicherstellen das die Angaben in den Bereich passen
    if ((count * step) > max - min) {
      throw 'Zahlen passen nicht in den Bereich';
    }
    //* neuen max machen, damit r mit den ganzen steps nicht zu groß wird
    max = max - ((count - 1) * step)

    let r = Math.floor(Math.random() * (1 + max - min)) + min;


    let result: number[] = [];
    //*Einen Step abziehen, weil in der nachfolgenden Schleife sonst r um einen Step zu groß wäre.
    //r = r-step

    // result.push(r);
    for (var i = 0; i < count; i++) {
      result.push(r);
      r = r + step;
    }

    return result;
  }


  public knuthShuffle(arr) {
    var rand, temp, i;
    //let r = Math.floor(Math.random() * (1 + 10 - 3)) + 3;


    for (i = arr.length - 1; i > 0; i -= 1) {
      rand = Math.floor((i + 1) * Math.random());//get random between zero and i (inclusive)
      temp = arr[rand];//swap i and the zero-indexed number
      arr[rand] = arr[i];
      arr[i] = temp;
    }

    return arr;
  }


  /**
   * Liefert eine  Liste mit Zahlen im angegebene Bereich in zufälliger Reihenfolge
   * 
   * @param {number} min kleinste Zahl
   * @param {number} max großte Zahl
   * @returns Liste mit Zahlen
   * @memberof MathProvider
   */
  public randomlist(min: number, max: number) {

    let arr = [];

    for (var i = min; i < max; i++) {
      arr.push(i);
    }

    arr.sort(function () { return 0.5 - Math.random() });

    return arr;
  }


  /** Liefert zufällige Zahlen im angebenen Bereich, angegbener Rechentyp und das Ergebnis
   * 
   * 
   * @param {number} minNumber Minimale Zahl 
   * @param {number} maxNumber Maximale Zahl 
   * @param {string} calcTyp Mögliche Werte: addition, subtraktion, multiplikation, division
   * @returns {any[]} 
   * @memberof MathProvider
   */
  public getrandomNumbers(minNumber: number, maxNumber: number, calcTyp: string): any[] {
    

    let t = [];
    switch (calcTyp) {
      case 'addition':
        

let maxtemp = maxNumber - minNumber;


        let summand1 = this.getrandomnumber(0, maxtemp);
        let summand2 = this.getrandomnumber(0, maxtemp-summand1);
        summand1 = summand1 + minNumber;
        summand2 = summand2 + minNumber;
        let summenwert = summand1 + summand2;


        t.push({ numbertyp: 'summand1', numbervalue: summand1 });
        t.push({ numbertyp: 'summand2', numbervalue: summand2 });
        t.push({ numbertyp: 'summenwert', numbervalue: summenwert });

        break;
      default:
        throw 'typ ist nicht vorhanden'
    }

    return t;
  }


/**Liefert zufälliges Ergebnis im angegeben Bereich, angebener Rechenart und die Zahlen.
 * 
 * 
 * @param {number} minResult Minimales Ergebnis
 * @param {any} maxResult Maximales Ergebnis
 * @param {string} calcTyp Mögliche Werte: addition, subtraktion, multiplikation, division
 * @returns {any[]} 
 * @memberof MathProvider
 */
public getRandomResult(minResult:number, maxResult, calcTyp:string): any[]{
  //todo hier Ergebnisse dei zwischen den Werten liegt
  let t = [];
  switch (calcTyp) {
    case 'addition':
      

      break;
    default:
      throw 'calcTyp ist nicht vorhanden'
  }

  return t;
}



}




// WEBPACK FOOTER //
// ./src/providers/math/math.ts